<template>
<div class="header">
    <div class="title">
      <svg-icon v-show="collapse" @click="handleCollapse" class-name="collapse-icon" icon-class="collapse-back"></svg-icon>
      {{ titleDate[headerTitle] }}
    </div>
    <div class="header-right">
      <div class="header-search" @click="gotoSearch" ref="tocaWikiSearchButton">
        <svg-icon class-name="search-icon" icon-class="header-search"></svg-icon>{{$t("搜索#!!!#src/pages/CloudHome/components/Header.vue_1")}}      </div>
      <Avatar v-if="!is_inTocaApp" @handleLogOutShow="logOutVisible = true"></Avatar>
    </div>

    <moo-dialog top="15vh" custom-class="sign-out-dialog" :visible.sync="logOutVisible" width="448px" @closed="logOutVisible = false">
      <div>
        <div class="title">
          <svg-icon class-name="dialog-icon" icon-class="file-warning"></svg-icon>{{$t("退出登录#!!!#src/pages/CloudHome/components/Header.vue_1")}}        </div>
        <div class="content">{{$t("确定退出登录吗？#!!!#src/pages/CloudHome/components/Header.vue_1")}}</div>
        <div class="footer">
          <div class="custom-button link-button" @click="logOutVisible = false">{{$t("取 消#!!!#src/pages/CloudHome/components/Header.vue_1")}}          </div>
          <div class="custom-button primary-button" @click="handleLogOut">{{$t("确 定#!!!#src/pages/CloudHome/components/Header.vue_1")}}          </div>
        </div>
      </div>
    </moo-dialog>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { mapState, mapActions } from "vuex";
import Avatar from "../components/avatar";
import { goLogin } from "@/utils/auth";
import { AGENT_ID, WEB_PATH } from "@/constants/auth";
import { setRedirectCallback } from "@/core/h5/request/index";

export default {
  name: "List",
  components: {
    Avatar
  },
  data() {
    return {
      logOutVisible: false,
      titleDate: {
        1: intl.$t("首页#!!!#src/pages/CloudHome/components/Header.vue_1"),
        2: intl.$t("我的文档#!!!#src/pages/CloudHome/components/Header.vue_1"),
        3: intl.$t("知识库#!!!#src/pages/CloudHome/components/Header.vue_1"),
        5: intl.$t("收藏#!!!#src/pages/CloudHome/components/Header.vue_1")
      },
      is_inTocaApp: navigator.userAgent.toLowerCase().indexOf("toca") !== -1
    };
  },
  emits: ["gotoSearch", "gotoAISearch"],
  created() {},
  mounted() {
    setRedirectCallback(() => {
      goLogin(window.location.href, AGENT_ID.cloudHome, true);
    });
    // 挂载AI搜索入口
    window.addEventListener('TocaWikiAiSearchEntryReady', this.initAiSearch, { once: true });
  },
  methods: {
    ...mapActions({
      setCollapse: "setCollapse"
    }),
    initAiSearch() {
      if (window.TocaWikiAiSearchEntry && this.$refs.tocaWikiSearchButton) {
        new window.TocaWikiAiSearchEntry(this.$refs.tocaWikiSearchButton, {
          style: 'transform: translateX(5px);',
          locale: this.cloudHomeI18n ||
          localStorage.getItem("tci18nLocale") ||
          navigatorLang[navigator.language] ||
          "zh-cn",
          onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
            this.$emit("gotoAISearch");
          }
        });
      }
    },
    gotoSearch() {
      this.$emit("gotoSearch");
    },
    handleCollapse() {
      this.setCollapse(false);
    },
    handleLogOut() {
      goLogin(window.location.href, AGENT_ID.cloudHome, true);
    }
  },
  computed: {
    ...mapState({
      headerTitle: (state) => state.headerTitle,
      collapse: (state) => state.collapse,
      currentUser: (state) => state.currentUserInfo,
      cloudHomeI18n: (state) => state.cloudHomeI18n
    }),
    memberUniqueId() {
      if ("undefined" == cookies.get("memberUniqueId")) {
        return this.currentUser.id;
      }
      return cookies.get("memberUniqueId") || this.currentUser.id;
    }
  }
};
</script>

<style lang="scss">
.header {
  width: 100%;
  height: 54px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  box-sizing: border-box;
  overflow: hidden;

  .title {
    font-weight: 600;
    font-size: 16px;
  }

  .collapse-icon {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }

  .header-right {
    display: flex;
    flex-flow: row;

    .header-search {
      cursor: pointer;
      width: 240px;
      height: 32px;
      background: #FFFFFF;
      border: 1px solid #E5E5E5;
      border-radius: 6px;
      display: flex;
      flex-flow: row;
      align-items: center;
      justify-content: flex-start;
      font-weight: 400;
      font-size: 14px;
      color: #656b74;
      padding: 0 8px;
      margin-right: 16px;

      &:hover {
        border-color: #5C70FF;
      }

      .search-icon {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
    }
  }
}

.sign-out-dialog {
  height: 172px;
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;

  .moo-dialog__header,
  .moo-dialog__body {
    padding: 0 !important;
  }

  .mobile-content {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;

    .title {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 17px;
      color: #121317;
      text-align: center;
      line-height: 24px;
    }

    .content {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #393d47;
      text-align: center;
      line-height: 20px;
    }

    .footer {
      display: flex;
      width: 100%;
      display: flex;
      flex-flow: row;
      justify-content: flex-end;
      margin-top: 32px;

      .custom-button {
        cursor: pointer;
        width: 126px;
        height: 44px;
        border: none;
        background: #f6f7f9;
        border-radius: 10px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #222329;
        text-align: center;
        line-height: 44px;
      }

      .primary-button {
        margin-left: 12px;
        background: #ff4747;
        color: #ffffff;
      }

      .reconnect-button {
        margin-left: 12px;
        background: #5c70ff;
        color: #ffffff;
      }
    }
  }

  .title {
    font-family: "PingFang SC", sans-serif;
    font-weight: 600;
    font-size: 16px;
    color: #000000d9;
    line-height: 24px;
    margin-bottom: 16px;

    .dialog-icon {
      width: 16px;
      height: 16px;
    }
  }

  .content {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #121317;
    padding-left: 24px;
  }

  .footer {
    display: flex;
    width: 100%;
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    margin-top: 32px;

    .custom-button {
      cursor: pointer;
      width: 76px;
      height: 32px;
      background: #ffffff;
      border: 1px solid #e8e9ee;
      border-radius: 4px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #222329;
      text-align: center;
      line-height: 32px;
    }

    .link-button {
      &:hover {
        background: #f4f6f9;
      }
    }

    .primary-button {
      margin-left: 12px;
      background: #ff4747;
      color: #ffffff;

      &:hover {
        background: #ff5f5f;
      }
    }

    .reconnect-button {
      margin-left: 12px;
      background: #5c70ff;
      color: #ffffff;

      &:hover {
        background: #6d7dff;
      }
    }
  }
}
</style>
